// src/components/Mercado.js
import React from 'react';
import './Mercado.css';

const Mercado = () => {
  const dadosMercado = [
    { titulo: 'TAM Global', valor: 'US$ 1,1 trilhão/ano', descricao: 'Mercado mundial de pecuária e tecnologia agro' },
    { titulo: 'SAM Brasil', valor: 'US$ 52–53 bi/ano', descricao: 'Mercado brasileiro de pecuária de corte e leite' },
    { titulo: 'SOM Maranhão', valor: 'US$ 550 milhões/ano', descricao: 'Mercado estadual com grande potencial de crescimento' }
  ];

  const oportunidades = [
    { icon: 'fas fa-chart-line', texto: 'Mercado nacional em crescimento com demanda por tecnologia no campo' },
    { icon: 'fas fa-file-export', texto: 'Exigências crescentes por rastreabilidade na exportação de carne' },
    { icon: 'fas fa-tachometer-alt', texto: 'Adoção de tecnologia no agronegócio em aceleração' },
    { icon: 'fas fa-globe-americas', texto: 'Potencial para expansão internacional em países da América Latina' }
  ];

  const diferenciais = [
    { icon: 'fas fa-horse', texto: 'Solução específica para equinos e bovinos' },
    { icon: 'fas fa-hand-holding-usd', texto: 'Tecnologia acessível para produtores de todos os portes' },
    { icon: 'fas fa-puzzle-piece', texto: 'Integração com sistemas existentes no mercado' },
    { icon: 'fas fa-user-md', texto: 'Suporte técnico especializado em medicina veterinária' }
  ];

  return (
    <section id="mercado" className="section">
      <div className="container">
        <span className="section-eyebrow">Oportunidade</span>
        <h2 className="section-title">Potencial de Mercado</h2>

        <div className="mercado-container">
          {dadosMercado.map((dado, index) => (
            <div key={index} className="mercado-card">
              <h3 className="mercado-titulo">{dado.titulo}</h3>
              <div className="mercado-valor">{dado.valor}</div>
              <p>{dado.descricao}</p>
            </div>
          ))}
        </div>
        
        <h3 className="mercado-subtitulo">Oportunidades de Expansão</h3>
        <div className="diferenciais-container">
          {oportunidades.map((oportunidade, index) => (
            <div key={index} className="diferencial-item">
              <i className={`${oportunidade.icon} diferencial-icon`}></i>
              <span>{oportunidade.texto}</span>
            </div>
          ))}
        </div>
        
        <h3 className="mercado-subtitulo">Diferenciais Competitivos</h3>
        <div className="diferenciais-container">
          {diferenciais.map((diferencial, index) => (
            <div key={index} className="diferencial-item">
              <i className={`${diferencial.icon} diferencial-icon`}></i>
              <span>{diferencial.texto}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Mercado;